import { t as outsideComponentT } from 'i18next';

import CalculatorLogo from 'assets/apply.clevry/Icon_Guide_01.png';
import WatchLogo from 'assets/apply.clevry/Icon_Guide_02.png';
import MobileLogo from 'assets/apply.clevry/Icon_Guide_04.png';
import DesktopLogo from 'assets/apply.clevry/Icon_Guide_05.png';

export const getBarClassName = (
    percentageComplete: number,
    isCompleted: boolean
  ) => {
    if (!isCompleted && percentageComplete >= 0 && percentageComplete < 100) {
      // return '#2A9A47';
      return '#036C8F';
    } else if (isCompleted || percentageComplete === 100) {
      // return '#f5f5f5';
      return '#2A9A47';
    } else {
      return '#f5f5f5';
    }
  };

export const getHelpIconText = (prongCode: string) => {
    switch (prongCode) {
    case 'PQ':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_PQ'
        );
    case 'SJT':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_SJT'
        );
    case 'Numerical':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Numerical'
        );
    case 'Verbal':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Verbal'
        );
    case 'Abstract':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Abstract'
        );
    case 'Mechanical':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Mechanical'
        );
    case 'Checking':
        return outsideComponentT(
        'SSCandidate_View_Application_Stages_Help_Icon_Checking'
        );
    default:
        return null;
    }
};

 export const getRequirementsIcons = (
    fullRequirements: { requirement: string }[]
  ) => {
    const requirementIcons: { [key: string]: string } = {
      Desktop: DesktopLogo,
      Mobile: MobileLogo,
      TimeLimit: WatchLogo,
      Calculator: CalculatorLogo,
    };
    if (fullRequirements) {
      return fullRequirements.map(
        (requirementWrapper: { requirement: string }) => {
          return (
            <img
              src={requirementIcons[requirementWrapper.requirement]}
              alt={outsideComponentT(
                'SSCandidate_View_Application_Stages_Alt_Requirement_Wrapper_Requirement'
              ) + requirementWrapper.requirement.toLowerCase()}
            />
          );
        }
      );
    }
    return null;
  };
